import { useEffect, useState } from "react";
import { useObserver } from "mobx-react-lite";
import { IItem } from "@Front/Components/DesignSystem/Menu/MenuItem";
import { useRolePermissionContext, useRolePermissionsLoading } from "@Front/Stores/RolePermissionsStore";
import { activeOfficeStore } from "@Front/Stores/ActiveOfficeStore";
import { resolveAndFilterOfficeMenuItems } from "../../../hooks/officeItemsFilteringHelpers";
import { attachGuestExitBeforeNavigateToOfficeMenuLinks } from "../../../hooks/officeMenuAttachGuestExitBeforeNavigate";
import { useExitGuestFoldersBeforeOfficeMenuNavigation } from "../../../hooks/useExitGuestFoldersBeforeOfficeMenuNavigation";
import { useRolePermissionsMatrixSnapshot } from "@Front/Hooks/useRolePermissionsMatrixSnapshot";

/**
 * Candidats « Espace office » pour le burger (garde-fous métier) ; filtrage matrice dans OfficeMenuSection.
 * Même résolution d’office métier que le menu header (`resolveNotaryMenuOfficeIdentity`).
 */
export function useBurgerModalOfficeItems(officeItems: IItem[], isOpen: boolean): IItem[] {
	const permissionContext = useRolePermissionContext();
	const loadingPermissions = useRolePermissionsLoading();
	const matrix = useRolePermissionsMatrixSnapshot();
	const [officeMenuCandidates, setOfficeMenuCandidates] = useState<IItem[]>([]);
	const exitGuestThenNavigate = useExitGuestFoldersBeforeOfficeMenuNavigation();

	const { activeOffice, availableOffices, lastRealQuiet } = useObserver(() => ({
		activeOffice: activeOfficeStore.activeOffice,
		availableOffices: activeOfficeStore.availableOffices,
		lastRealQuiet: activeOfficeStore.peekLastRealOfficeUidBeforeGuest(),
	}));

	useEffect(() => {
		if (!isOpen) {
			return;
		}
		const filtered = resolveAndFilterOfficeMenuItems({
			permissionContext,
			loadingPermissions,
			permissionsMatrix: matrix,
			activeOffice,
			availableOffices,
			lastRealOfficeUidBeforeGuest: lastRealQuiet,
			officeItems,
		});
		setOfficeMenuCandidates(attachGuestExitBeforeNavigateToOfficeMenuLinks(filtered, exitGuestThenNavigate));
	}, [
		isOpen,
		permissionContext,
		loadingPermissions,
		matrix,
		officeItems,
		activeOffice,
		availableOffices,
		lastRealQuiet,
		exitGuestThenNavigate,
	]);

	return officeMenuCandidates;
}
